module.exports = __webpack_public_path__ + "img/s3.9ae08ed8.png";